import z from 'zod';

export const DateFilterOperatorSchema = z.object({
  $gt: z.string().optional(),
  $gte: z.string().optional(),
  $lt: z.string().optional(),
  $lte: z.string().optional(),
}).refine(value => Object.keys(value).length > 0, {
  message: 'At least one date filter operator is required',
});
